"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no draft object of given courseId and id exists
 * @param {string} courseId
 * @param {string} id
 */
class DraftObjectDoesNotExistError extends client_library_1.ExtendableError {
    constructor(courseId, id) {
        super(`draft object: courseId ${courseId}, id ${id} does not exist`);
        this.courseId = courseId;
    }
}
exports.default = DraftObjectDoesNotExistError;
//# sourceMappingURL=DraftObjectDoesNotExistError.js.map